import { render, staticRenderFns } from "./EGraficoPorCategoria.vue?vue&type=template&id=31be5220&scoped=true"
import script from "./EGraficoPorCategoria.vue?vue&type=script&lang=js"
export * from "./EGraficoPorCategoria.vue?vue&type=script&lang=js"
import style0 from "./EGraficoPorCategoria.vue?vue&type=style&index=0&id=31be5220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be5220",
  null
  
)

export default component.exports